// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-card-body[data-v-73b7c47b]{min-height:10vh;max-height:75vh;overflow-y:auto;display:block}.favorites-options[data-v-73b7c47b]{display:block}.new-option[data-v-73b7c47b]{display:flex;margin-top:2rem}.new-option>button[data-v-73b7c47b]{flex:0 0 auto;margin-left:1rem}.option>input[data-v-73b7c47b]{margin-right:.5rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
